/**
 * Default shape for a new product. One blank variant pre-populated so
 * the variants section has at least one row to edit on first open.
 */
export const emptyProduct = () => ({
  name: '',
  description: '',
  category: '',
  status: 'draft',
  base_price: 0,
  currency: 'USD',
  track_inventory: true,
  requires_shipping: true,
  options: [],
  images: [],
  variants: [{ sku: '', attributes: {}, price: null, is_active: true }],
});

export const emptyVariant = () => ({
  sku: '', attributes: {}, price: null, is_active: true,
});

export const emptyImage = (existing = []) => ({
  url: '', alt: '',
  is_primary: existing.length === 0,
  sort_order: existing.length,
});
